import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, Grid, Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import { Post, apiURL } from '../../../utils/apiCalls';
import { toast } from 'react-toastify';
import RenderRazorpay from '../agents/RenderRazorpay';

const SubscriptionLogout = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [orderDetails, setOrderDetails] = useState({
    orderId: null,
    currency: null,
    amount: null,
  });
  const [loader, setLoader] = useState(null);  // Track loader for specific plan
  const [displayRazorpay, setDisplayRazorpay] = useState(false);
  const [account, setAccount] = useState();
  const [logoutPage,setLogoutPage] = useState(false)


  return (
    <Box sx={{ padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '40px' }}>
    <Typography variant="h5" gutterBottom>
      Please log in to access the subscription plans.
    </Typography>
    <Button
      variant="outlined"
      sx={{
        backgroundColor: '#1976d2', // Blue color
        '&:hover': { backgroundColor: '#1565c0' },
        color: '#fff',
        fontWeight: 600,
        borderRadius: '30px',
        padding: '12px',
      }}
      onClick={() => window.location.href = '/#/login'} // Redirect to login page
    >
      Log In
    </Button>
  </Box>
    </Box>
  );
};

// Styled components for a premium card appearance
const StyledCard = styled(Card)(({ selected }) => ({
  width: 340,
  cursor: 'pointer',
  border: `2px solid ${selected ? '#1976d2' : '#dcdcdc'}`, // Grey border when unselected
  borderRadius: '16px',  // Rounded corners
  transition: 'transform 0.3s, box-shadow 0.3s',
  boxShadow: selected
    ? `0px 8px 25px rgba(0, 0, 0, 0.2)`
    : `0px 6px 15px rgba(0, 0, 0, 0.15)`,
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 12px 30px rgba(0, 0, 0, 0.25)`,
    backgroundColor: '#fff',  // Keep white background on hover
  },
  backgroundColor: '#fff', // White background for the card
  color: '#000',  // Text color black for better readability
  padding: '16px',
}));

export default SubscriptionLogout;
